import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { getStripe } from "@atlas/billing";
import { config } from "../config";

interface CheckoutModalProps {
  clientSecret: string;
  onClose: () => void;
}

/**
 * Checkout modal using Stripe Embedded Checkout
 * - Uses EmbeddedCheckoutProvider and EmbeddedCheckout from @stripe/react-stripe-js
 * - Modal overlay with close button
 */
export function CheckoutModal({
  clientSecret,
  onClose,
}: CheckoutModalProps): React.ReactElement {
  const stripePromise = getStripe(config.stripe.publishableKey);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-surface rounded-lg w-full max-w-2xl max-h-[90vh] overflow-auto relative shadow-xl">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center rounded text-text-tertiary hover:text-text-primary hover:bg-bg transition-colors duration-150 bg-transparent border-none text-sm cursor-pointer z-10"
          aria-label="Close checkout"
        >
          &times;
        </button>

        <div className="p-4">
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      </div>
    </div>
  );
}
